import React from "react";
import { AlertTriangle, Check, X } from "lucide-react";
import "./styles/custom-alert.css";

const CustomAlert = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  confirmText = "Yes",
  cancelText = "No",
  type = "warning",
  loading = false,
}) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <div className="custom-alert-overlay" onClick={handleCancel}>
      <div
        className="custom-alert-container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="alert-header">
          <div className={`custom-alert-icon ${type}`}>
            <AlertTriangle />
          </div>
          <h3 className="custom-alert-title">{title}</h3>
        </div>

        <div className="custom-alert-content">
          <p className="custom-alert-message">{message}</p>
        </div>

        <div className="alert-actions">
          <button
            className="alert-btn custom-cancel-btn"
            onClick={handleCancel}
          >
            <X className="btn-icon" />
            {cancelText}
          </button>
          <button
            className={`alert-btn custom-confirm-btn ${type}`}
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? (
              <div className="loading-spinner-small"></div>
            ) : (
              <Check className="btn-icon" />
            )}
            {loading ? "" : confirmText}
          </button>
        </div>

        <div className="alert-glow"></div>
      </div>
    </div>
  );
};

export default CustomAlert;
